import React from "react";
import { intl } from "LocaleWrapper";
import { FormGroup } from "@cofano/cck";
import { Day } from "types/enums";
import { FormattedTime } from "utils/DateUtils";
import { OpeningHoursFragment } from "__generated__/view/relations/graphql/relation.fragments.generated";

export const OpeningHoursDetails = ({ hours }: { hours: OpeningHoursFragment | null }) => {
	return (
		<React.Fragment>
			{Object.values(Day).map(day => (
				<FormGroup
					label={intl.formatMessage({ id: day.toUpperCase() })}
					labelPlacement="left-center"
					overflow="hidden"
					key={day}>
					<FormattedTime minutes={hours?.[`${day}From`] || undefined} />
					{" - "}
					<FormattedTime minutes={hours?.[`${day}To`] || undefined} />
				</FormGroup>
			))}
		</React.Fragment>
	);
};
